module.exports = __webpack_public_path__ + "3975e84054c21daff2fe2368840e9b65.jpg";